import React, { Fragment } from 'react';
import { Form, Button } from 'semantic-ui-react';
// import { forEach, toLower } from 'lodash';
import { compose } from 'recompose';
import { withLocalize } from 'react-localize-redux';
import * as Yup from 'yup';
import { Field, withFormik } from 'formik';

import { HHSingleSelect, HHTextArea, HHTinyMCE } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import ConfirmationModal from '../common/confirmationModal';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) =>
    Yup.object().shape({
      type: Yup.string().required(translate('form.error.mixed.required')),
      to: Yup.string().required(translate('form.error.mixed.required')),
      emailTitle: Yup.string().required(translate('form.error.mixed.required')),
      content: Yup.string().required(translate('form.error.mixed.required'))
    }),
  mapPropsToValues: props => props.initialValues,
  handleSubmit: (values, { props, resetForm, setSubmitting }) => {
    props.handleSubmit(values).then(() => {
      setSubmitting(false);
      resetForm();
      if (props.handleClose) {
        props.handleClose();
      }
    });
  },
  displayName: FORM_NAME.CMS_ANNOUNCEMENT_FORM_EDIT
});

const AnnouncementForm = props => {
  const {
    values,
    eventSlug,
    userToken,
    isEditing,
    handleSubmit,
    handleClose,
    isSubmitting,
    translate
  } = props;

  let roleOptions = [];
  roleOptions = [
    { value: 'All', label: translate('common.all') },
    { value: 'Participant', label: translate('common.participant') },
    { value: 'Mentor', label: translate('common.mentor') },
    { value: 'Judge', label: translate('common.judge') },
    { value: 'Volunteer', label: translate('common.volunteer') }
  ];

  let typeOptions = [];
  typeOptions = [
    { value: 'PLATFORM', label: translate('common.platform') },
    { value: 'EMAIL', label: translate('common.email') },
    { value: 'SMS', label: translate('common.sms') }
  ];

  // forEach(event.roleTitles, title =>
  // roleOptions.push({ value: title, label: translate(`common.${toLower(title)}`) }));

  return (
    <Form className='cms-announcement_table_form'>
      <Form.Field className='cms-announcement_table_form_sendTo'>
        <label htmlFor='type'>{translate('form.label.sendType')}</label>
        <Field
          name='type'
          component={HHSingleSelect}
          otherProps={{
            id: 'type',
            simpleValue: true,
            searchable: false,
            clearable: false,
            options: typeOptions,
            placeholder: translate('form.label.sendType')
          }}
        />
      </Form.Field>

      {values.type !== 'PLATFORM' && (
        <Form.Field className='cms-announcement_table_form_sendTo'>
          <label htmlFor='to'>{translate('form.label.to')}</label>
          <Field
            name='to'
            component={HHSingleSelect}
            otherProps={{
              id: 'to',
              simpleValue: true,
              searchable: false,
              clearable: false,
              options: roleOptions,
              placeholder: translate('form.label.to')
            }}
          />
        </Form.Field>
      )}

      {values.type !== 'SMS' && (
        <Form.Field className='cms-announcement_table_form_message'>
          <Fragment>
            <label htmlFor='form-content'>
              {values.type === 'PLATFORM' ? translate('form.label.title') : translate('form.label.emailTitle')}
            </label>
            <Field
              name='emailTitle'
              component={HHTextArea}
              otherProps={{ id: 'form-emailTitle' }}
            />
          </Fragment>
        </Form.Field>
      )}

      <Form.Field className='cms-announcement_table_form_message'>
        <label htmlFor='form-content'>{translate('form.label.message')}</label>
        {values.type !== 'SMS' ? (
          <Field
            name='content' component={HHTinyMCE} fileType='event_announcement_description'
            slug={eventSlug} userToken={userToken}
          />
        ) : (
          <Field
            name='content'
            component={HHTextArea}
            otherProps={{ id: 'form-content' }}
          />
        )}
      </Form.Field>

      <div className='cms-announcement_table_form_button'>
        {handleClose && (
          <Button basic type='button' onClick={handleClose}>
            {translate('cancel')}
          </Button>
        )}

        <ConfirmationModal
          title={translate(
            isEditing
              ? 'form.confirmationTitle.sureToUpdateAnnouncement'
              : 'form.confirmationTitle.sureToSendAnnouncement'
          )}
          cancelText={translate('no')}
          confirmText={translate('yes')}
          handleConfirm={handleSubmit}
          disabled={isSubmitting || !values.content}
          trigger={
            <Button
              loading={isSubmitting}
              primary
              disabled={isSubmitting || !values.content}
              type='button'
            >
              {isEditing
                ? translate('form.submitBtn.update')
                : translate('form.submitBtn.send')}
            </Button>
          }
        />
      </div>
    </Form>
  );
};

export default compose(
  withLocalize,
  formikEnhancer
)(AnnouncementForm);



// WEBPACK FOOTER //
// ./src/components/forms/announcementForm.js